export default __webpack_public_path__ + "static/media/auto-repair (1).38b2f2aa.svg";